/*
 * 生命银行所用的订单操作OrderAction映射
 */
export default {
  name: 'ADULT_LIFEBANK_ACTIONS',
  statuses: [
    {
      name: 'CREATE',
      description: '样本创建',
      operation: '样本创建',
      icon: ''
    },
    {
      name: 'LAB_SAMPLES_RECEIVED',
      description: '样本接收',
      operation: '样本接收',
      icon: ''
    },
    {
      name: 'PREPARED',
      description: '制备',
      operation: '制备',
      icon: ''
    },
    {
      name: 'WAREHOUSING',
      description: '入库',
      operation: '入库',
      icon: ''
    },
    {
      name: 'REPORT_CHECKED_1ST',
      description: '报告生成',
      operation: '报告生成',
      icon: ''
    },
    {
      name: 'COMPLETED',
      description: '已完成',
      operation: '完成',
      icon: ''
    }
  ]
}
